import {
  getDynamicUiDataFromEntityWithFieldMetadata,
  getInitialFormData,
} from './dynamicUiInitialValuesHelpers';
import { useForm } from '@mantine/form';
import { EntityWithFieldMetadata, FormValuesType } from './types';
import DynamicUiRenderer from './DynamicUiRenderer';
import { prepFormValuesForUpsert } from 'src/non-financial-data/prepFormValuesForUpsert';
import { Stack } from '@mantine/core';
import React from 'react';
import { UpsertEntityInput } from 'src/data-capture/merge-review/useUpsertEntities';

type Props = {
  entity: EntityWithFieldMetadata;
  fieldsToHide?: string[];
  footer?: React.ReactNode;
  onSubmit?: (upsertEntities: UpsertEntityInput[]) => unknown;
  filterUntouchedFields?: boolean;
};

export function EntityForm({
  entity,
  fieldsToHide = ['client_id', 'id'],
  footer = null,
  onSubmit = () => {},
  filterUntouchedFields = true,
}: Props) {
  const initialDataInput = getDynamicUiDataFromEntityWithFieldMetadata(entity);
  const form = useForm<FormValuesType>({
    mode: 'uncontrolled',
    ...getInitialFormData(initialDataInput, initialDataInput.ui.layout),
  });

  const renderFields = () => {
    const uiRenderer = new DynamicUiRenderer(form, initialDataInput);
    return initialDataInput.ui.layout
      .filter(item => item.type !== 'FIELD' || !fieldsToHide?.includes(item.entityField))
      .map(item => uiRenderer.renderItem(item));
  };

  const handleSubmit = (formValues: FormValuesType) => {
    const valuesToSubmit = prepFormValuesForUpsert(
      formValues,
      initialDataInput,
      form,
      !filterUntouchedFields,
    );
    onSubmit(valuesToSubmit);
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>{renderFields()}</Stack>
      {footer}
    </form>
  );
}
